var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5957_13237)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 49.5,
    width: 49,
    height: 49,
    rx: 24.5,
    transform: "rotate(180 49.5 49.5)",
    stroke: "#0C94FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4949 29.8144L31.1863 27.0025C32.2712 26.1761 32.2712 24.8239 31.1863 23.9975L22 17M22 34L23.4653 32.8838",
    stroke: "#0C94FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5957_13237"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(180 50 50)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.850ac844dd923fd9105d7932c4f0eed8.svg";
export { ForwardRef as ReactComponent };